import type { Action } from '@0xtorch/core'
import type { LowerHex } from '../../../types'
import type { TransactionDecoded } from '../../../types/transactionDecoded'

type CreateActionsByFailAnalyzerParameters = {
  transaction: TransactionDecoded
  relatedAddresses: Set<LowerHex>
  source: string
}

export const createActionsByFailAnalyzer = ({
  transaction,
  relatedAddresses,
  source,
}: CreateActionsByFailAnalyzerParameters): readonly Action[] | undefined => {
  if (transaction.status !== 'reverted') {
    return undefined
  }

  if (!relatedAddresses.has(transaction.from.address)) {
    return undefined
  }

  return [
    {
      type: 'fail-tx',
      timestamp: transaction.timestamp,
      source,
      order: 0,
      evidence: 'system-rule',
      transfers: [],
      app: transaction.to?.app ?? transaction.from.app,
    },
  ]
}
